import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ab094bd"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "aboutme-title own-font" }, "Impressum", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Angaben gemäß § 5 TMG:", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, " Yusuf Kavalci "),
  /*#__PURE__*/_createElementVNode("li", null, " Steuerberater "),
  /*#__PURE__*/_createElementVNode("li", null, " Haberspirkerstraße 32 "),
  /*#__PURE__*/_createElementVNode("li", null, " 86529 Schrobenhausen ")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Vertreten durch:", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, " Steuerberater Yusuf Kavalci ")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Kontakt:", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode("Telefon: "),
    /*#__PURE__*/_createElementVNode("a", { href: "tel:+4982529638812" }, "08252 / 9638812")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode("Mobil: "),
    /*#__PURE__*/_createElementVNode("a", { href: "tel:+4917613697053" }, "0176 / 13697053")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, " E-Mail: info@steuerberatung-kavalci.de ")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Gesetzliche Berufsbezeichnung: ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, " Steuerberater ")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Die gesetzliche Berufsbezeichnung „Steuerberater“ wurde in der Bundesrepublik Deutschland (Bayern) verliehen. ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Zuständige Aufsichtsbehörde:", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, " Steuerberaterkammer München "),
  /*#__PURE__*/_createElementVNode("li", null, " Körperschaft des öffentlichen Rechts "),
  /*#__PURE__*/_createElementVNode("li", null, " Nederlingerstr. 9 "),
  /*#__PURE__*/_createElementVNode("li", null, " 80638 München ")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Der Berufsstand der Steuerberater unterliegt im Wesentlichen nachfolgenden berufsrechtlichen Regelungen:", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, " 1. Steuerberatungsgesetz (StBerG) "),
  /*#__PURE__*/_createElementVNode("li", null, " 2. Durchführungsverordnung zum Steuerberatungsgesetz (DVStB) "),
  /*#__PURE__*/_createElementVNode("li", null, " 3. Berufsordnung der Bundessteuerberaterkammer (BOStB) "),
  /*#__PURE__*/_createElementVNode("li", null, " 4. Steuerberatervergütungsverordnung (StBVV) ")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Umsatzsteuer wird gem. § 19 (1) UStG nicht ausgewiesen. ", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Berufshaftpflichtversicherung:", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, " Die Berufshaftpflichtversicherung besteht bei der R+V Allgemeine Versicherung AG "),
  /*#__PURE__*/_createElementVNode("li", null, " Mittlerer Pfad 24, 70499 Stuttgart "),
  /*#__PURE__*/_createElementVNode("li", null, " Versicherungsnummer: 407 84 354863430 S "),
  /*#__PURE__*/_createElementVNode("li", null, " Haftungssumme je Versicherungsfall: 250.000 Euro ")
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Online-Streitbeilegung:", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, " Plattform der EU-Kommission zur Online-Streitbeilegung: http://ec.europa.eu/consumers/odr "),
  /*#__PURE__*/_createElementVNode("li", null, " Wir sind zur Teilnahme an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle weder verpflichtet noch bereit. ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        title: _withCtx(() => [
          _hoisted_1
        ]),
        default: _withCtx(() => [
          _createVNode(_component_v_list, {
            lines: "one",
            class: "own-font begining-text"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item, {
                "prepend-icon": "mdi-chevron-right",
                class: "datenschutz-list-item"
              }, {
                default: _withCtx(() => [
                  _hoisted_2,
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_v_list_item, {
                "prepend-icon": "mdi-chevron-right",
                class: "datenschutz-list-item"
              }, {
                default: _withCtx(() => [
                  _hoisted_4,
                  _hoisted_5
                ]),
                _: 1
              }),
              _createVNode(_component_v_list_item, {
                "prepend-icon": "mdi-chevron-right",
                class: "datenschutz-list-item"
              }, {
                default: _withCtx(() => [
                  _hoisted_6,
                  _hoisted_7
                ]),
                _: 1
              }),
              _createVNode(_component_v_list_item, {
                "prepend-icon": "mdi-chevron-right",
                class: "datenschutz-list-item"
              }, {
                default: _withCtx(() => [
                  _hoisted_8,
                  _hoisted_9
                ]),
                _: 1
              }),
              _createVNode(_component_v_list_item, {
                "prepend-icon": "mdi-chevron-right",
                class: "datenschutz-list-item"
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              }),
              _createVNode(_component_v_list_item, {
                "prepend-icon": "mdi-chevron-right",
                class: "datenschutz-list-item"
              }, {
                default: _withCtx(() => [
                  _hoisted_11,
                  _hoisted_12
                ]),
                _: 1
              }),
              _createVNode(_component_v_list_item, {
                "prepend-icon": "mdi-chevron-right",
                class: "datenschutz-list-item"
              }, {
                default: _withCtx(() => [
                  _hoisted_13,
                  _hoisted_14
                ]),
                _: 1
              }),
              _createVNode(_component_v_list_item, {
                "prepend-icon": "mdi-chevron-right",
                class: "datenschutz-list-item"
              }, {
                default: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 1
              }),
              _createVNode(_component_v_list_item, {
                "prepend-icon": "mdi-chevron-right",
                class: "datenschutz-list-item"
              }, {
                default: _withCtx(() => [
                  _hoisted_16,
                  _hoisted_17
                ]),
                _: 1
              }),
              _createVNode(_component_v_list_item, {
                "prepend-icon": "mdi-chevron-right",
                class: "datenschutz-list-item"
              }, {
                default: _withCtx(() => [
                  _hoisted_18,
                  _hoisted_19
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}